<div class="wfm-dropdown" #dropdown (wfmOutsideMousedown)="outsideMousedown()">
  <div class="wfm-dropdown-trigger" (click)="triggerClick()">
    <ng-content select="[slot=trigger]"></ng-content>
  </div>
</div>

<ng-template #dropdownContentTemplate>
  <div
    #dropdownContent
    (mousedown)="contentMousedown()"
    class="wfm-dropdown-content menu__panel"
    [attr.aria-hidden]="!isOpen"
    [class.dark-theme]="darkTheme"
    [ngClass]="defaultPosition"
    [ngStyle]="getStyle(dropdownContent)"
  >
    <div *ngIf="scrollbar; else contentProjection" wfmScrollbar style="min-width: 100%">
      <ng-container [ngTemplateOutlet]="contentProjection"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #contentProjection>
  <ng-content></ng-content>
</ng-template>
